export default {
  companyStatisticMetadata: {
    employeesOnAdaptation: 'Сотрудников на адаптации',
    employeesCount: 'Количество подключенных сотрудников',
    availableLicenses: 'Доступно лицензий',
    started: 'Запущено',
    lastSend: 'Последняя отправка',
    nearestSend: 'Ближайшая отправка',
    employeesEvaluated: 'Оценено сотрудников',
    motivation: 'Мотивация',
    teamRoles: 'Структура личности и роли в команде',
    numOfSurveys: 'Количество отправленных опросов',
    numOfAnswers: 'Количество ответов на вопросы',
    createSurveys: 'Создайте опросы и назначьте<br />их сотрудникам',
    noData: 'Нет данных',
    imageAlt: 'Пустой график пульс-опросов',
    evaluationProgress: 'Прогресс оценки',
    notStarted: 'Не начато',
    inProgress: 'В работе',
    finished: 'Завершено',
    withRoadmaps: 'Сотрудников с планами развития по текущей оценке',
    totalTargets: 'всего целей',
    efficiency: 'эффективность',
    testsFinished: 'Завершено тестов',
  },
};
